import {
  Box,
  Tooltip,
  Typography,
  styled,
  withStyles
} from '@material-ui/core';

export const AIContainer = styled(Box)({
  flex: 1,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundImage: 'url(/images/SETVIAI.png)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top right'
});

export const AITitle = styled(Typography)({
  width: 'fit-content',
  fontWeight: 'bold',
  background:
    'linear-gradient(155deg, #001222 2%, #003A6C  25%,  #3896E0  85%, #1E96FC  100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginBottom: 6
});

export const ImagePreview = withStyles({
  tooltip: {
    padding: '2px !important',
    borderRadius: 12
  }
})(Tooltip);

export const Precentage = styled(Box)(({ theme }) => ({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  borderRadius: 12,
  width: 'fit-content',
  fontSize: 13,
  height: 24,
  gap: 4,
  color: '#4D4D4D',
  padding: theme.spacing(0, 2),
  cursor: 'default',

  '& p': {
    margin: theme.spacing('2px', 0, 0, '2px')
  }
}));
